module.exports = __webpack_public_path__ + "img/loading.4c4d9c52.png";